import {
  Component,
  h,
  Prop,
  Method,
  Host,
  ComponentInterface,
} from '@stencil/core';
import { sanitizeHTML } from '../../utils/htmlSanitizer';

@Component({
  tag: 'signet-accordion-slide',
})
export class AccordionSlide implements ComponentInterface {
  slideId: number = slideIds++;
  controlId = `accordion_control_${this.slideId}`;
  panelId = `accordion_slide_${this.slideId}`;
  $slideContent: HTMLElement;

  /**
   * The text heading for the accordion slide.
   */
  @Prop() heading: string;
  /**
   *  A boolean indicating whether the slide is expanded or not, defaulting to false.
   */
  @Prop() expanded = false;
  /**
   *  The HTML content to be displayed in the slide.
   */
  @Prop() htmlContent: string;
  /**
   *  A boolean indicating if the slide is pending.
   */
  @Prop() pending: boolean;
  /**
   *  A boolean indicating if the slide is completed.
   */
  @Prop() completed: boolean;
  /**
   *  A boolean indicating if the accordion should be borderless.
   */
  @Prop() borderless = false;
  /**
   *  A boolean indicating if the slide is a child slide.
   */
  @Prop() isChild = false;
  /**
   *  A boolean indicating if the child accordion has a trailing line.
   */
  @Prop() childTrailingLine = false;
  /**
   *  A boolean indicating if the parent accordion has a trailing line.
   */
  @Prop() parentTrailingLine = false;
  /**
   *  The HTML content to be displayed in the subheading.
   *
   */
  @Prop() subHeadingHtmlContent: string;

  @Method()
  /**
   *  A method to toggle the slide open or closed.
   */
  async toggleSlide() {
    this.expanded = !this.expanded;
    // this.$slideContent.style.maxHeight = this.expanded
    //   ? this.$slideContent.scrollHeight + 32 + 'px'
    //   : '0px';
    this.$slideContent.style.maxHeight = this.expanded ? 'fit-content' : '0px';
    this.$slideContent.style.overflow = this.expanded
        ? 'visible'
        : 'hidden';

  }

  componentDidRender() {
    if (this.expanded)
      // this.$slideContent.style.maxHeight = this.expanded
      //   ? this.$slideContent.scrollHeight + 32 + 'px'
      //   : '0px';
      this.$slideContent.style.maxHeight = this.expanded ? 'fit-content' : '0px';
      this.$slideContent.style.overflow = this.expanded
        ? 'visible'
        : 'hidden';
  }

  render() {
    const classes = {
      'accordion-slide': true,
      borderless: this.borderless,
      'is-child': this.isChild,
      'child-trailing-line': this.childTrailingLine,
      'parent-trailing-line': this.parentTrailingLine,
    };

    const btnClasses = {
      'accordion-control': true,
      'is-child': this.isChild,
    };
    return (
      <Host class={classes}>
        <h3 class="accordion-heading">
          <button
            id={this.controlId}
            class={btnClasses}
            aria-controls={this.panelId}
            aria-expanded={`${this.expanded}`}
            onClick={() => this.toggleSlide()}
          >
            <div class="accordion-start">
              {this.pending && (
                <signet-icon icon="do_not_disturb_on" variant='outlined' class="pending-icon" />
              )}
              {this.completed && (
                <signet-icon icon="check_circle" class="completed-icon" />
              )}
              <div class="heading-start">
                <span
                  ref={(el) =>
                    (el.innerHTML = sanitizeHTML(this.heading) as string)
                  }
                ></span>
                <span>
                  {this.subHeadingHtmlContent && (
                    <div
                      class="sub-heading-html-content"
                      innerHTML={this.subHeadingHtmlContent}
                    ></div>
                  )}
                </span>
              </div>
            </div>
            {this.htmlContent && (
              <span class="html-with-icon">
                {this.htmlContent && (
                  <div
                    class="accordion-html-content"
                    innerHTML={this.htmlContent}
                  ></div>
                )}
                <div class="accordion-icon-container">
                  <signet-icon
                    class="accordion-icon"
                    icon="keyboard_arrow_down"
                  />
                </div>
              </span>
            )}
          </button>
        </h3>
        <section
          id={this.panelId}
          class="accordion-content"
          aria-hidden={`${!this.expanded}`}
          aria-labelledby={this.controlId}
          ref={(el) => (this.$slideContent = el)}
        >
          <slot />
        </section>
      </Host>
    );
  }
}

let slideIds = 0;
